import { SearchInput } from '@synoptic/ui-kit/input/search-input.js';
import { useCallback, useTransition } from 'react';
import { useSearchParams } from 'react-router';
import { useDebouncedCallback } from 'use-debounce';
import { useRedesign } from '@/feature-flags/redesign/use-redesign.ts';
import { deleteSearchParams } from '@/utils/handle-search-param';
import { useStreamPostsLoaderData } from './loader';
import { streamPostsSearch } from './page.css';

export const StreamPostsSearch = () => {
  const redesign = useRedesign();
  const [isPending, startTransition] = useTransition();
  const { q } = useStreamPostsLoaderData();

  const [, setSearchParams] = useSearchParams();

  const debouncedSetSearchParams = useDebouncedCallback(
    (...args: Parameters<typeof setSearchParams>) =>
      startTransition(() => setSearchParams(...args)),
    200,
  );

  const onValueChange = useCallback(
    (value?: string) => {
      const query = value || '';
      if (query.length === 0) {
        setSearchParams((prev) => deleteSearchParams(prev, ['q']), {
          preventScrollReset: true,
        });
        debouncedSetSearchParams.cancel();
      } else {
        debouncedSetSearchParams(
          (prev) => {
            const next = new URLSearchParams(prev);
            next.set('q', query);
            return next;
          },
          { preventScrollReset: true },
        );
      }
    },
    [debouncedSetSearchParams, setSearchParams],
  );

  return (
    <SearchInput
      loading={isPending}
      placeholder={redesign ? 'Filter events' : 'Filter posts...'}
      onQueryChange={onValueChange}
      defaultValue={q}
      containerClassName={streamPostsSearch}
    />
  );
};
